import { render, staticRenderFns } from "./addArticle.vue?vue&type=template&id=2f461f8c&scoped=true"
import script from "./addArticle.vue?vue&type=script&lang=js"
export * from "./addArticle.vue?vue&type=script&lang=js"
import style0 from "./addArticle.vue?vue&type=style&index=0&id=2f461f8c&prod&lang=scss"
import style1 from "./addArticle.vue?vue&type=style&index=1&id=2f461f8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f461f8c",
  null
  
)

export default component.exports